import CategoriesSelect from "@/components/form/categories-select";
import {
  makePickerField,
  type PickerFieldProps,
} from "@/fields/_internal/make-picker-field";

/** **Value is a list of category ids** (`string[]`). */
export type CategoriesFieldProps = PickerFieldProps<string[]>;

export const CategoriesField = makePickerField<string[]>({
  name: "CategoriesField",
  control: CategoriesSelect,
  popout: true,
});
